import { Text } from '@cko/primitives';
import styled from 'styled-components';
export const StyledSwitchText = styled(Text) `
  font: var(--heading-md);
  margin-bottom: var(--layout-shoe);
`;
export const StyledBlockedModal = styled.div `
  display: flex;
  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--base-border-secondary);
  border-radius: var(--border-r-shoe);
  flex-direction: column;
  padding: var(--layout-shoe);
  width: 380px;
  z-index: var(--z-order-floating-element);
  position: relative;
`;
export const StyledButtonContainer = styled.div `
  display: flex;
  gap: var(--layout-spoon);
`;
